module.exports = __webpack_public_path__ + "static/sylwia-8510bf7ca1399cfcd258909d64ebc9e1.png";